import type { MoonPayProvider as BaseMoonPayProvider } from "@moonpay/moonpay-react"
import { type ComponentProps, type ComponentType, lazy } from "react"

export const MoonPayProvider: ComponentType<
  ComponentProps<typeof BaseMoonPayProvider>
> = lazy(() =>
  import("@moonpay/moonpay-react").then(mod => ({
    default: mod.MoonPayProvider,
  })),
)

export const MoonPayNftCheckoutWidget = lazy(() =>
  import("@moonpay/moonpay-react").then(mod => ({
    default: mod.MoonPayNftCheckoutWidget,
  })),
)

export const MoonPayBuyWidget = lazy(() =>
  import("@moonpay/moonpay-react").then(mod => ({
    default: mod.MoonPayBuyWidget,
  })),
)
